import { render, staticRenderFns } from "./VideoContainer.vue?vue&type=template&id=021cd88b&scoped=true&"
import script from "./VideoContainer.vue?vue&type=script&lang=ts&"
export * from "./VideoContainer.vue?vue&type=script&lang=ts&"
import style0 from "./VideoContainer.vue?vue&type=style&index=0&id=021cd88b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cd88b",
  null
  
)

export default component.exports